import { Dispatch, SetStateAction, useEffect } from 'react';
import {
  ReferenceItem,
  ReferenceValue,
  ReferenceValueDelimiter,
} from '../../../../../../types/types';
import { isReferenceValueInSync } from '../utils/isReferenceValueInSync';

type UseExternalValueResetOptions = {
  isFormInput: boolean;
  value: ReferenceValue;
  selectedItems: ReferenceItem[];
  isMultiselect: boolean | undefined;
  delimiter: ReferenceValueDelimiter;
  setSelectedItems: Dispatch<SetStateAction<ReferenceItem[]>>;
  setChipsValue: Dispatch<SetStateAction<string[]>>;
  setInputValue: Dispatch<SetStateAction<string>>;
};

// Re-resolves the displayed label when value changes externally (e.g. sequential-edit
// row switch). Reads the current (stale) selectedItems on purpose: a user selection
// keeps them in sync, so the guard skips the reset and never clobbers the pick.
// Form-only: column filters keep value/selectedItems in sync themselves.
const useExternalValueReset = ({
  isFormInput,
  value,
  selectedItems,
  isMultiselect,
  delimiter,
  setSelectedItems,
  setChipsValue,
  setInputValue,
}: UseExternalValueResetOptions): void => {
  useEffect(() => {
    if (!isFormInput) return;
    if (
      isReferenceValueInSync(
        value,
        selectedItems,
        Boolean(isMultiselect),
        delimiter
      )
    ) {
      return;
    }
    setSelectedItems([]);
    setChipsValue([]);
    setInputValue('');
  }, [value]);
};

export default useExternalValueReset;
